/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_1_NeedInputs */

const en_pc_alt_pick_1_need = /** @type {(inputs: Pc_Alt_Pick_1_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You mostly read, comment, fill forms and reorder pages`)
};

const zh_pc_alt_pick_1_need = /** @type {(inputs: Pc_Alt_Pick_1_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要是阅读、批注、填表和调整页面顺序`)
};

/**
* | output |
* | --- |
* | "You mostly read, comment, fill forms and reorder pages" |
*
* @param {Pc_Alt_Pick_1_NeedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_1_need = /** @type {((inputs?: Pc_Alt_Pick_1_NeedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_1_NeedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_1_need(inputs)
	return zh_pc_alt_pick_1_need(inputs)
});
export { pc_alt_pick_1_need as "pc.alt.pick.1.need" }